// extracted by mini-css-extract-plugin
export default {"color-list":"ColorList_color-list__kuCAv"};